import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-custom-snackbar',
  templateUrl: './custom-snackbar.component.html',
  styleUrls: ['./custom-snackbar.component.scss'],
})
export class CustomSnackBarComponent { 
  constructor(private dialogRef: MatDialogRef<CustomSnackBarComponent>) {}

  closeDialog() {
    this.dialogRef.close();
  }
}